import { isDemoStudentId } from "./buildDemoStudentProfile";

/**
 * Boletim (GET Academics/student/:ra/report-cards-external).
 */
export function buildDemoReportCards(studentId) {
  if (!isDemoStudentId(studentId)) {
    return { reportCards: [] };
  }

  const now = new Date().toISOString();

  return {
    reportCards: [
      {
        id: "rc-demo-1",
        updatedAt: now,
        course: {
          name: "Ensino Fundamental — demonstração",
          coursePeriodDescription: `${new Date().getFullYear()}`
        },
        academicPeriods: [
          {
            name: "1º bimestre — demonstração",
            data: {
              geralAverageData: {
                color: "#00b2b9",
                average: { value: "8,5", color: "#00b2b9" }
              },
              admissionStatusData: {
                color: "#2e7d32",
                value: "Aprovado"
              },
              disciplines: [
                {
                  id: "demo-disc-pt",
                  name: "Português — demonstração",
                  color: "#00b2b9",
                  teacher: "Prof. Demo Waybee",
                  mainAverages: [
                    {
                      value: "8,5",
                      color: "#00b2b9",
                      description: "Média aritmética"
                    }
                  ],
                  evaluations: [
                    {
                      id: "ev-p1",
                      description: "Prova 1",
                      maxNote: "10",
                      color: "#00b2b9",
                      value: "8"
                    },
                    {
                      id: "ev-p2",
                      description: "Prova 2",
                      maxNote: "10",
                      color: "#00b2b9",
                      value: "9"
                    }
                  ]
                },
                {
                  id: "demo-disc-mat",
                  name: "Matemática — demonstração",
                  color: "#00b2b9",
                  teacher: "Prof. Demo Waybee",
                  mainAverages: [
                    {
                      value: "8,0",
                      color: "#00b2b9",
                      description: "Média aritmética"
                    }
                  ],
                  evaluations: [
                    {
                      id: "ev-m1",
                      description: "Avaliação",
                      maxNote: "10",
                      color: "#00b2b9",
                      value: "8"
                    }
                  ]
                }
              ]
            }
          }
        ]
      }
    ]
  };
}
